var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjacent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 10,
    d: "m491,94.4l-73.8-74c-12.5-12.5-35.4-12.5-47.8,0l-157,157.4c-7.3,6.3-10.4,14.6-10.4,24-8.8,0-17.7,3.1-23.9,9.4l-157.1,157.4c-7.3,6.3-10.4,14.6-10.4,24 0,9.4 4.2,17.7 10.4,24l73.8,74c6.2,7.3 14.6,10.4 23.9,10.4 9.4,0 17.7-4.2 23.9-10.4l157-157.4c7-6 10.2-14 10.4-22.9 8.3,0 16.6-4.2 23.9-10.4l157-157.4c12.2-11.8 13.4-33.8 0.1-48.1zm-204.8,224.2l-157.1,157.4c-5.2,5.2-14.6,5.2-19.8,0l-73.8-74c-4.7-4.6-6-12.6 0-18.8l157-156.4c5.8-5.7 14.8-6 19.8-1l29.5,29.6-52.8,53 14.7,14.7 52.8-53 29.6,29.7c6.5,6.9 5,14 0.1,18.8zm191.3-190.8l-157,157.4c-5.2,5.2-14.6,5.2-19.8,0l-29.6-29.7 51.7-51.9-14.7-14.7-51.7,51.9-29.5-29.6c-4.8-4.3-5.3-14.4 0-18.8l157-157.4c5.5-5.2 14-5.6 19.8,0l73.8,74c5.6,6.1 3.6,15.6 0,18.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjacent);
export default __webpack_public_path__ + "static/media/adjacent.2a23b2b31119563c143a345df2a2e058.svg";
export { ForwardRef as ReactComponent };